/** Pull — threads pull between the stroke and where it has just been. */
import type { CreateModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { PathSegment, Point } from '../../core/scene';
import { defaultStyle } from '../../core/scene';
import { distance } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 20 20 4"/><path d="M5 13 13 5"/><path d="M11 19 19 11"/></svg>';

export function createPull(): CreateModule {
  let pts: Point[] = [];
  let drawing = false;

  return {
    manifest: {
      id: 'pull',
      kind: 'create',
      name: 'Web',
      apiVersion: 1,
      description: 'A web of threads back to where your mark has been.',
      icon: ICON,
      params: [
        { kind: 'slider', key: 'reach', label: 'Reach', min: 2, max: 60, step: 1, default: 16 },
      ],
    },

    onPointerDown(s) {
      pts = [{ x: s.x, y: s.y }];
      drawing = true;
    },

    onPointerMove(s) {
      if (!drawing) return;
      const p = { x: s.x, y: s.y };
      const last = pts[pts.length - 1];
      if (!last || distance(last, p) >= 2) pts.push(p);
    },

    onPointerUp() {
      drawing = false;
    },

    getLiveShapes(ctx) {
      if (pts.length < 2) return [];
      const reach = Math.round(cfgNum(ctx.config, 'reach', 16));
      const segs: PathSegment[] = [];
      segs.push({ t: 'M', p: { ...pts[0] } });
      for (let i = 1; i < pts.length; i++) segs.push({ t: 'L', p: { ...pts[i] } });
      for (let i = 0; i < pts.length; i += 2) {
        const j = Math.max(0, i - reach);
        if (j === i) continue;
        segs.push({ t: 'M', p: { ...pts[i] } });
        segs.push({ t: 'L', p: { ...pts[j] } });
      }
      const style = defaultStyle();
      style.lineWidth = 1;
      style.color = { ...ctx.ink, a: 0.7 };
      return [ctx.newShape({ path: { segments: segs }, style })];
    },

    onClear() {
      pts = [];
    },

    onCommit() {
      pts = [];
    },
  };
}
